var mixin_viewport = {
    data () {
        return {
            screen: '' // phone, tablet, desktop
        }
    },
    mounted(){

        jQuery(document).on("ini-ready", ()=>{
            this.defineScreen()
        })

        jQuery(document).on("window-resized", ()=>{
            this.defineScreen()
        });

    },
    methods:{
        defineScreen(){
            this.screen = api.vars.is
        }
    }
}